import {Component, Inject, OnInit} from "@angular/core";
import {NavigationExtras, Router} from "@angular/router";
import {AuthService} from "../../services";
import {environment} from "../../../../environments/environment";
import {DOCUMENT} from '@angular/common';
import {FacilityService} from "../../services/location/location.service";
import {UtilService} from "../../services/util/util.service";

@Component({
  selector: "app-physician-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  animations: [] // [routerTransition()]
})
export class PhysicianPortalLoginComponent implements OnInit {
  loginInvalid: boolean = false;

  password: string = "";
  username: string = "";
  system: string = "";
  ver: string = `${environment.versions.version}-${environment.envName}` || "N/A";
  appTitle: string = "Physician Portal";

  constructor(public router: Router,
              private authService: AuthService,
              @Inject(DOCUMENT) private document: Document,
              private facilityService: FacilityService,
              private utilService: UtilService) {
    this.ver = this.utilService.getEnvironmentString(environment)
  }

  ngOnInit() {
    sessionStorage.clear();
    this.system = this.extractSystemName();
  }

  extractSystemName(document: Document = this.document) {
    const {hostname} = document.location;
    const systemName = hostname.replace(environment.domain, '').replace('.', '')
    if (!systemName.includes(hostname)) return systemName;
    return '';
  }

  onLogin(formValues) {
    this.loginInvalid = false; // reset
    let loginPayload: LoginPayload = {
      Username: formValues.username,
      Password: formValues.password
    };

    this.authService
      .authenticatePhysician(loginPayload)
      .then(() => {
        this.router.navigate([''])
      })
      .catch((error: any) => {
        this.loginInvalid = true;
      });
  }

  forgotPassword() {
    let navigationExtras: NavigationExtras = {
      queryParams: {redirect: "/login"}
    };
    this.router.navigate(["/password/forgot"], navigationExtras);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/login/physician-portal-login.component.ts